<template>
  <VApp>
    <TheSiteHeader />

    <VContent>
      <VContainer
        fluid
        class="mainContainer pt-0"
      >
        <transition
          appear
          name="fade-transition"
          mode="out-in"
        >
          <router-view />
        </transition>
      </VContainer>
    </VContent>

    <TheSiteFooter />

    <TheCookieBar />

    <router-link :to="{ name: 'SzechenyiPlanPlus' }">
      <img
        class="SzechenyiPlanPlusImage"
        src="@/assets/szechenyiplus.png"
      >
    </router-link>

    <router-link :to="{ name: 'SzechenyiPlan' }">
      <img
        class="SzechenyiPlanImage"
        src="@/assets/szechenyi2020.png"
      >
    </router-link>
  </VApp>
</template>

<script>
import TheSiteHeader from '@/components/TheSiteHeader.vue';
import TheSiteFooter from '@/components/TheSiteFooter.vue';
import TheCookieBar from '@/components/TheCookieBar.vue';

export default {
  name: 'App',
  components: {
    TheSiteHeader,
    TheSiteFooter,
    TheCookieBar,
  },
};
</script>

<style>
img, .v-icon {
  user-select: none;
}

.theme--light.application {
  background-color: white;
}

.pacifico {
  font-family: 'Pacifico', cursive !important;
}

.mainContainer {
  margin: auto;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .mainContainer {
    width: calc(100vw - 17px);
  }
}

.fullWidth {
  margin: 0 -24px 0 -24px;
}

@media (max-width: 959px) {
  .fullWidth {
    margin: 0 -16px 0 -16px;
  }
}

.maximize {
  max-width: 1600px;
  margin: auto;
}

.SzechenyiPlanPlusImage {
  position: fixed;
  width: 250px;
  height: 175px;
  left: 0;
  bottom: 0;
  z-index: 3;
}

@media (max-width: 600px) {
  .SzechenyiPlanPlusImage {
    width: 200px;
    height: 140px;
  }
}

.SzechenyiPlanImage {
  position: fixed;
  width: 250px;
  height: 175px;
  right: 0;
  bottom: 0;
  z-index: 3;
}

@media (max-width: 600px) {
  .SzechenyiPlanImage {
    width: 200px;
    height: 140px;
  }
}
</style>
